import { datetime } from './datetime';
import { surveyUrl } from '~/config/settings/worktango.settings';

export const buildSurveyPreviewLink = (previewHash: string): string => {
  return `${surveyUrl}/survey/${previewHash}`;
};

export const buildOpenSurveyLink = (openSurveyUuid: string): string => {
  return `${surveyUrl}/s/${openSurveyUuid}`;
};

export const buildOpenSurveyBypassLink = (openSurveyUuid: string, accessCode: string): string => {
  return `${buildOpenSurveyLink(openSurveyUuid)}?c=${encodeURIComponent(accessCode)}`;
};

// When getting an UTC offset from the BE we need to account for the offset based on the timezone
// of the survey as well as the local time of the React APP (based on browser/location).
export const convertUTCTimeToLocalWithOffset = (
  datetimeUTC: string | null,
  timezone: string | undefined,
): Date | null => {
  if (!datetimeUTC) return null;
  const startTimeAsJSDatetime = isNaN(Number(datetimeUTC)) ? new Date(datetimeUTC) : new Date(parseInt(datetimeUTC));

  // Convert the UTC time to the provided timezone
  return timezone ? datetime.utcToZonedTime(startTimeAsJSDatetime, timezone) : startTimeAsJSDatetime;
};
